"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLineBarChart = void 0;
var ChartGroupConfig_init_1 = require("@/pages/common/states/ChartGroupConfig.init");
var getColour_1 = require("@/pages/common/transformers/getColour");
var getFixMax_1 = require("@/pages/common/transformers/getFixMax");
exports.getLineBarChart = function (chartState, isMobile) {
    if (isMobile === void 0) { isMobile = false; }
    var values = Array.from(Array(chartState.yValues.length)).map(function (_, i) { return ({
        color: chartState.yLineColors[i] || getColour_1.getColour(i, chartState.yValues.length),
        label: chartState.yLabels[i],
        series: chartState.yValues[i],
        size: 0,
    }); });
    var defaultConfig = JSON.parse(JSON.stringify(ChartGroupConfig_init_1.chartGroupConfigMultiLineMultiBar));
    var defaultBar = JSON.parse(JSON.stringify(defaultConfig.charts[0]));
    var defaultLine = JSON.parse(JSON.stringify(defaultConfig.charts[1]));
    var thickness = chartState.yCounts[0].length > 20 ? 18 : chartState.yCounts[0].length > 10 ? 30 : 60;
    var fontSize = 23;
    var step = 5;
    var barFixMax = getFixMax_1.getFixMax(Math.max.apply(Math, chartState.yCounts.flatMap(function (it) { return it; })), step);
    var lineFixMax = getFixMax_1.getFixMax(Math.max.apply(Math, chartState.yValues.flatMap(function (it) { return it; })), step);
    var getLabelMultiplyer = function () {
        if (isMobile) {
            return 1.3;
        }
        if (chartState.xLabels.length > 18) {
            return 0.7;
        }
        return 1.0;
    };
    var config = __assign(__assign({}, defaultConfig), { merged: true, charts: [__assign(__assign({}, defaultBar), { type: 'multibar', thickness: thickness, height: 800, backgroundLineColor: '#ccc', values: chartState.yCounts.map(function (it, i) {
                    return __assign(__assign({}, defaultBar.values[0]), { series: it, color: chartState.yCountColor[i], color2: chartState.yCountColor2[i] });
                }), xAxis: __assign(__assign({}, defaultBar.xAxis), { label: '', series: chartState.xLabels, fontSize: fontSize, marginStart: isMobile ? 260 : defaultBar.xAxis.marginStart, marginEnd: isMobile ? 180 : defaultBar.xAxis.marginEnd + 30, color: '#333', xLabelWidthMultiplyer: getLabelMultiplyer() }), yAxis: __assign(__assign({}, defaultBar.yAxis), { color: '#333', label: chartState.yCountTitle[0].split(' - ')[0], fontSize: fontSize, fixMax: barFixMax, fixMaxExtend: barFixMax * 3, fixStep: step, marginEnd: isMobile ? 160 : defaultBar.yAxis.marginEnd }) }), __assign(__assign({}, defaultLine), { values: values, height: 800, thickness: thickness, xAxis: __assign(__assign({}, defaultLine.xAxis), { label: '', series: chartState.xLabels, fontSize: fontSize, marginStart: isMobile ? 260 : defaultLine.xAxis.marginStart, marginEnd: isMobile ? 180 : defaultLine.xAxis.marginEnd + 30, xLabelWidthMultiplyer: getLabelMultiplyer() }), yAxis: __assign(__assign({}, defaultLine.yAxis), { color: '#333', label: chartState.yTitle, fontSize: fontSize, fixMax: lineFixMax, fixStep: step, marginEnd: isMobile ? 160 : defaultLine.yAxis.marginEnd }) })] });
    return config;
};
